import React, { Component } from "react";
import { Table, Button, Col, Row } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";

const { Column } = Table;

class BalancoPrintModal extends Component {
    state = {
        listaRegistros: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        if (!stateAnte.visualizar && this.state.visualizar) {
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });

        const { buscaDataIni, buscaDataFim, buscaNumero, buscaControle,
            buscaPessoa, buscaPlanoCta, buscaCtaCorrente, buscaTipoDoc,
            buscaDescricao } = this.props.filtros;

        let dataIni = '';
        if ((buscaDataIni) && (buscaDataIni !== undefined)) {
            dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }
        let dataFim = '';
        if ((buscaDataFim) && (buscaDataFim !== undefined)) {
            dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
        }

        if ((buscaDataIni) && (buscaDataFim)) {

            if (this.props.tela === 'resultado') {

                axios
                    .get('/titulos/listaBalancoFinancResultado', {
                        params: {
                            print: true,
                            dataIni,
                            dataFim,
                        }
                    })
                    .then(response => {
                        const { data } = response;
                        this.setState({
                            listaRegistros: data,
                            carregando: false,
                        });
                    })
                    .catch(erro => {
                        console.warn(erro);
                        this.setState({
                            carregando: false,
                        });
                    });

            } else {

                let buscaTipoAux = '';
                let buscaSituacaoAux = '';
                if (this.props.tela === 'entradas') {
                    buscaTipoAux = 'E';
                    buscaSituacaoAux = 'P';
                } else if (this.props.tela === 'saidas') {
                    buscaTipoAux = 'S';
                    buscaSituacaoAux = 'P';
                } else if (this.props.tela === 'receber') {
                    buscaTipoAux = 'E';
                    buscaSituacaoAux = 'A';
                } else if (this.props.tela === 'pagar') {
                    buscaTipoAux = 'S';
                    buscaSituacaoAux = 'A';
                }

                axios
                    .get('/titulos/listaBalancoFinanc', {
                        params: {
                            print: true,
                            controle: buscaControle,
                            numero: buscaNumero,
                            descricao: buscaDescricao,
                            tipo: buscaTipoAux,
                            situacao: buscaSituacaoAux,
                            pessoa: buscaPessoa.key,
                            ctaFin: buscaPlanoCta.key,
                            tipoDoc: buscaTipoDoc.key,
                            ctaCorrente: buscaCtaCorrente.key,
                            dataIni,
                            dataFim,
                        }
                    })
                    .then(response => {
                        const { data } = response;
                        this.setState({
                            listaRegistros: data,
                            carregando: false,
                        });
                    })
                    .catch(erro => {
                        console.warn(erro);
                        this.setState({
                            carregando: false,
                        });
                    });
            }
        } else {
            this.setState({
                listaRegistros: [],
                carregando: false,
            });
        }

    };

    onCancelar = () => {
        this.setState({
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }



    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            return (
                <span></span>
            )
        }
    }


    renderValor = (vlr) => {
        return (
            <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
        );
    };

    renderValorCred = (tpp_valor, registro) => {
        if (registro.pc_tipo === 'E') {
            return (
                <span> {numeral(parseFloat(tpp_valor)).format('0,000.00')} </span>
            );
        } else {
            return (
                <span>-</span>
            );
        }
    };

    renderValorDeb = (tpp_valor, registro) => {
        if (registro.pc_tipo === 'S') {
            return (
                <span> {numeral(parseFloat(tpp_valor)).format('0,000.00')} </span>
            );
        } else {
            return (
                <span>-</span>
            );
        }
    };

    renderParcela = (tparc_parcela, registro) => {
        return (
            <span> {tparc_parcela + ' / ' + registro.qtde_parcelas} </span>
        );
    };

    renderValorEnt = (vlr, registro) => {
        if (registro.pc_tipo === 'E') {
            return (
                <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
            );
        } else {
            return (
                <span>-</span>
            );
        }
    };

    renderValorSai = (vlr, registro) => {
        if (registro.pc_tipo === 'S') {
            return (
                <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
            );
        } else {
            return (
                <span>-</span>
            );
        }
    };


    render() {
        const { listaRegistros, carregando, visualizar } = this.state;
        return (
            <span>
                <Button onClick={this.onVisualizar}>
                    Impressão
                </Button>

                <PrintModal
                    visible={visualizar}
                    onCancel={this.onCancelar}
                >
                    <div >
                        <div className="titulo">
                            {this.props.tela === 'resultado' ? (
                                <span>Balanço Financeiro - Resultado</span>
                            ) : null}
                            {this.props.tela === 'entradas' ? (
                                <span>Balanço Financeiro - Entradas</span>
                            ) : null}
                            {this.props.tela === 'saidas' ? (
                                <span>Balanço Financeiro - Saídas</span>
                            ) : null}
                            {this.props.tela === 'receber' ? (
                                <span>Balanço Financeiro - Contas à Receber</span>
                            ) : null}
                            {this.props.tela === 'pagar' ? (
                                <span>Balanço Financeiro - Contas à Pagar</span>
                            ) : null}
                        </div>

                        <Row>
                            <Col xs={11} style={{ marginTop: 10, marginLeft: 40, textAlign: "left" }} >
                                <span style={{ fontWeight: "bold" }}>Período: </span>
                                <span>{this.props.periodo}</span>
                            </Col>
                            <Col xs={11} style={{ marginTop: 10, marginLeft: 20, textAlign: "right" }} >
                                {this.props.tela === 'entradas' ? (
                                    <div>
                                        <span style={{ fontWeight: "bold" }}>Valor Total: </span>
                                        <span>R$ {this.renderValor(this.props.vlrEntradas)}</span>
                                    </div>
                                ) : null}
                                {this.props.tela === 'saidas' ? (
                                    <div>
                                        <span style={{ fontWeight: "bold" }}>Valor Total: </span>
                                        <span>R$ {this.renderValor(this.props.vlrSaidas)}</span>
                                    </div>
                                ) : null}
                                {this.props.tela === 'receber' ? (
                                    <div>
                                        <span style={{ fontWeight: "bold" }}>Valor Total: </span>
                                        <span>R$ {this.renderValor(this.props.vlrReceber)}</span>
                                    </div>
                                ) : null}
                                {this.props.tela === 'pagar' ? (
                                    <div>
                                        <span style={{ fontWeight: "bold" }}>Valor Total: </span>
                                        <span>R$ {this.renderValor(this.props.vlrPagar)}</span>
                                    </div>
                                ) : null}
                            </Col>
                        </Row>

                        {this.props.tela === 'resultado' ? (
                            <div style={{ marginLeft: 40 }}>
                                <Row>
                                    <Col xs={22} style={{ marginTop: 10, marginLeft: 20, textAlign: "left" }} >
                                        <Col xs={7}>
                                            <span style={{ fontWeight: "bold" }}>Valor Entradas: </span>
                                            <span>R$ {this.renderValor(this.props.vlrEntradas)}</span>
                                        </Col>
                                        <Col xs={7}>
                                            <span style={{ fontWeight: "bold" }}>Valor Saídas: </span>
                                            <span>R$ {this.renderValor(this.props.vlrSaidas)}</span>
                                        </Col>
                                        <Col xs={7}>
                                            <span style={{ fontWeight: "bold" }}>Resultado: </span>
                                            <span>R$ {this.renderValor(this.props.vlrResultado)}</span>
                                        </Col>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={22} style={{ marginLeft: 20, textAlign: "left" }} >
                                        <Col xs={7}>
                                            <span style={{ fontWeight: "bold" }}>Ctas à Receber: </span>
                                            <span>R$ {this.renderValor(this.props.vlrReceber)}</span>
                                        </Col>
                                        <Col xs={7}>
                                            <span style={{ fontWeight: "bold" }}>Ctas à Pagar: </span>
                                            <span>R$ {this.renderValor(this.props.vlrPagar)}</span>
                                        </Col>
                                        <Col xs={7}>
                                            <span style={{ fontWeight: "bold" }}>Provisão: </span>
                                            <span>R$ {this.renderValor(this.props.vlrProvisao)}</span>
                                        </Col>
                                    </Col>
                                </Row>
                            </div>
                        ) : null}

                        <Row style={{ marginTop: -20 }}>
                            {this.props.tela === 'resultado' ? (
                                <Table
                                    pagination={false}
                                    dataSource={listaRegistros}
                                    className="tabela"
                                    rowKey={(listaRegistros => listaRegistros.pc_descricao)}
                                    loading={{
                                        spinning: carregando,
                                        tip: 'Carregando. Aguarde...',
                                        size: "large"
                                    }}
                                >
                                    <Column
                                        key="pc_descricao"
                                        dataIndex="pc_descricao"
                                        title="Conta Financeira"
                                        width={50}
                                        align="left"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="vlr1"
                                        dataIndex="vlr"
                                        title="Entradas"
                                        render={this.renderValorEnt}
                                        width={20}
                                        align="right"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="vlr2"
                                        dataIndex="vlr"
                                        title="Saídas"
                                        render={this.renderValorSai}
                                        width={20}
                                        align="right"
                                        className="listaCadastro"
                                    />
                                </Table>
                            ) : null}

                            {this.props.tela === 'entradas' || this.props.tela === 'saidas' ? (
                                <Table
                                    pagination={false}
                                    dataSource={listaRegistros}
                                    className="tabela"
                                    rowKey={(listaRegistros => listaRegistros.tit_idf + '_' + listaRegistros.tparc_parcela)}
                                    loading={{
                                        spinning: carregando,
                                        tip: 'Carregando. Aguarde...',
                                        size: "large"
                                    }}
                                >
                                    <Column
                                        key="pgto_data"
                                        dataIndex="pgto_data"
                                        title="Data Pagto"
                                        render={this.renderData}
                                        width={120}
                                        align="left"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="pc_abreviatura"
                                        dataIndex="pc_abreviatura"
                                        title="Conta"
                                        width={80}
                                        align="left"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="pgto_vlr_pago"
                                        dataIndex="pgto_vlr_pago"
                                        title="Valor Pagto"
                                        render={this.renderValor}
                                        width={120}
                                        align="right"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="tparc_parcela"
                                        dataIndex="tparc_parcela"
                                        title="Parcela"
                                        width={80}
                                        align="center"
                                        className="listaCadastro"
                                        render={this.renderParcela}
                                    />
                                    <Column
                                        key="td_descricao"
                                        dataIndex="td_descricao"
                                        title="Tipo Docto"
                                        width={120}
                                        align="left"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="tit_controle"
                                        dataIndex="tit_controle"
                                        title="Controle"
                                        width={90}
                                        align="left"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="tit_numero"
                                        dataIndex="tit_numero"
                                        title="Número"
                                        width={90}
                                        align="left"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="pes_nome"
                                        dataIndex="pes_nome"
                                        title="Nome"
                                        width={150}
                                        align="left"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="tit_descricao"
                                        dataIndex="tit_descricao"
                                        title="Descrição"
                                        width={150}
                                        align="left"
                                        className="listaCadastro"
                                    />
                                </Table>
                            ) : null}

                            {this.props.tela === 'receber' || this.props.tela === 'pagar' ? (
                                <Table
                                    pagination={false}
                                    dataSource={listaRegistros}
                                    className="tabela"
                                    rowKey={(listaRegistros => listaRegistros.tit_idf + '_' + listaRegistros.tparc_parcela)}
                                    loading={{
                                        spinning: carregando,
                                        tip: 'Carregando. Aguarde...',
                                        size: "large"
                                    }}
                                >
                                    <Column
                                        key="tparc_data_parcela"
                                        dataIndex="tparc_data_parcela"
                                        title="Data Venc"
                                        render={this.renderData}
                                        width={120}
                                        align="left"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="pc_abreviatura"
                                        dataIndex="pc_abreviatura"
                                        title="Conta"
                                        width={80}
                                        align="left"
                                        className="listaCadastro"
                                        render={this.renderCtaFin}
                                    />
                                    <Column
                                        key="tparc_valor"
                                        dataIndex="tparc_valor"
                                        title="Vlr Parc"
                                        render={this.renderValor}
                                        width={100}
                                        align="right"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="pgto_vlr_pago"
                                        dataIndex="pgto_vlr_pago"
                                        title="Vlr Pago"
                                        render={this.renderValor}
                                        width={100}
                                        align="right"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="pgto_vlr_restante"
                                        dataIndex="pgto_vlr_restante"
                                        title="Vlr Rest"
                                        render={this.renderValor}
                                        width={100}
                                        align="right"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="tparc_parcela"
                                        dataIndex="tparc_parcela"
                                        title="Parc"
                                        width={70}
                                        align="center"
                                        className="listaCadastro"
                                        render={this.renderParcela}
                                    />
                                    <Column
                                        key="td_descricao"
                                        dataIndex="td_descricao"
                                        title="Tipo Doc"
                                        width={110}
                                        align="left"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="tit_controle"
                                        dataIndex="tit_controle"
                                        title="Contr"
                                        width={80}
                                        align="left"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="tit_numero"
                                        dataIndex="tit_numero"
                                        title="Núm"
                                        width={80}
                                        align="left"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="pes_nome"
                                        dataIndex="pes_nome"
                                        title="Nome"
                                        width={100}
                                        align="left"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="tit_descricao"
                                        dataIndex="tit_descricao"
                                        title="Descrição"
                                        width={100}
                                        align="left"
                                        className="listaCadastro"
                                    />
                                </Table>
                            ) : null}
                        </Row>
                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default BalancoPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/BalancoPrintModal.js